import React from 'react'
import { BuyingSessionSidebarStore } from '../stores/BuyingSessionSidebarStore'

export const BuyingSessionSidebarContext = React.createContext({
  buyingSessionSidebarStore: new BuyingSessionSidebarStore()
})
